<div class="popup-container">
    <div  *ngIf="isOptionsLoaded">
        <div class="d-flex heading-box">
            <div class="flex-grow-1 v-center">{{data.title}}</div>
            <div class="v-center"><mat-icon class="close-icon" (click)="closePopup()" (keydown.enter)="closePopup()">close</mat-icon></div>
        </div>
        <div class="popup-body px-4 pt-4">
            <div class="row px-0 mx-0">
                <div class="lable-text">Release Name</div>
                <app-dropdown-with-sections [config]="relaseConfig" [fields]="releaseOptions" [selectedValue]="selectedRelease" (onSelect)="updateRelease($event)"></app-dropdown-with-sections>
            </div>
            <div class="row button-space mx-0 justify-content-end">
                <button type="button" class="btn  btn-transparent-outlined" (click)="closePopup()">Cancel</button>
                <button type="button" class="btn  btn-accello-primary" [class]="selectedRelease.trim()=='' ? 'not-allowed': ''" [disabled]="selectedRelease.trim()==''" (click)="save()">Save</button>
            </div>
        </div>
    </div>
    <div  *ngIf="!isOptionsLoaded" class="load-wrap v-center">
        <app-loading [text]="'Loading data'"></app-loading>
    </div>
</div>